import { render, staticRenderFns } from "./TaskDetailsModal.vue?vue&type=template&id=28a74ad5&scoped=true"
import script from "./TaskDetailsModal.vue?vue&type=script&lang=js"
export * from "./TaskDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailsModal.vue?vue&type=style&index=0&id=28a74ad5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a74ad5",
  null
  
)

export default component.exports